export const GET_ALL_REFERENCE = 'GET_ALL_REFERENCE'
export const DELETE_REFERENCE_BY_ID = 'DELETE_REFERENCE_BY_ID'
export const GET_REFERENCE_BY_ID = 'GET_REFERENCE_BY_ID'
export const EDIT_REFERENCE_BY_ID = 'EDIT_REFERENCE_BY_ID'
